import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PaymentReceipt from "../payment-receipt/payment-receipt.component";
import { modifyHeader } from "../../actions/appStatus.actions";
import { restartApp } from "../../actions/appRestart.actions";
import { paymentCompleteHeader } from "../../utils/content";
import { getWebsiteUrl } from "../../utils/content";
import Show from "../../utils/show.component";
import { formatDate } from "../../utils/utils";
import ReactGA from "react-ga";
import AspireCrossSell from "../cross-sells/aspire-cross-sell.component";

class ProcessCompleteComponent extends Component {
  componentDidMount() {
    // Change header
    ReactGA.pageview(
      `payments.laketrust.org${window.location.pathname}`,
      [],
      "Loan Payments - Process Complete"
    );
    this.props.modifyHeader(paymentCompleteHeader.header, paymentCompleteHeader.description);
  }

  showAspireCrossSell = () => {
    const { payment } = this.props;
    return payment && payment.CrossSell && payment.CrossSell.ShowAspireSavings;
  };

  render() {
    return (
      <div className="container app-container">
        <div className="row">
          <div className="col-12">
            <Show condition={this.showAspireCrossSell()}>
              <AspireCrossSell />
            </Show>
            <PaymentReceipt
              description={this.props.loans.Description}
              loanNumber={this.props.loans.LoanNumber}
              nextDueDate={this.props.loans.NextDueDate}
              PaymentAmount={this.props.payment.PaymentAmount}
              NameOnCard={this.props.payment.NameOnCard}
              CardType={this.props.payment.CardType}
              PostDate={this.props.payment.PostDate}
              LoanNumberLastFour={this.props.payment.LoanNumberLastFour}
              CardNumberLastFour={this.props.payment.CardNumberLastFour}
              confirmationNumber={this.props.payment.ConfirmationNumber}
              paymentType={this.props.appStatus.paymentType}
              FeeAmount={this.props.payment.FeeAmount}
              ChargeOffIsRequired={this.props.loans.ChargeOffIsRequired}
              modifyHeader={this.props.modifyHeader}
              payoffCheck={this.props.payoffCheck}
              feeType={this.props.payment.feeType}
            />
          </div>
        </div>
        {/* Show payoff warning if this loan payment type was changed to payoff on the backend */}
        <Show condition={this.props.payoffCheck.PaymentTypeChangedToPayoff === true}>
          <div className="row">
            <div className="col-12 p-0">
              <div className="payoff-msg primary">
                Payment will be applied on or before {formatDate(this.props.payment.PostDate)}. This
                payment will result in the <u>payoff of this loan.</u>
              </div>
            </div>
          </div>
        </Show>
        {/* Only show the restart/done link if this is a non-appraisal, and set the text based on if it was a payoff */}
        <div className="row">
          <div className="col-12">
            <Show condition={this.props.appStatus.paymentType !== "Appraisal"}>
              <a href="#" onClick={this.props.restartApp} className="button full primary">
                {this.props.payoffCheck.PaymentTypeChangedToPayoff === true
                  ? "Done"
                  : "Make Another Payment"}
              </a>
            </Show>
            <div className="link-container">
              <a href={getWebsiteUrl()} target="_blank" className="uppercase">
                Back to Laketrust.org
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Map global store to component props
const mapStateToProps = (state) => state;

// Hook up actions to component
const mapDispatchToProps = {
  modifyHeader,
  restartApp,
};

//Connect to Redux store
const ProcessComplete = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProcessCompleteComponent)
);

export default ProcessComplete;



// WEBPACK FOOTER //
// ./src/components/process-complete/process-complete.component.js